import type { RefObject } from 'react'

import { useEffect, useState } from 'react'

type Size = {
    width: number
    height: number
}

/** Measures an element and follows it as it resizes. Starts at zero so the server render stays empty and stable. */
export function useElementSize<T extends Element>(ref: RefObject<T | null>): Size {
    const [size, setSize] = useState<Size>({ width: 0, height: 0 })

    useEffect(() => {
        const node = ref.current
        if (!node) return

        const update = () => {
            const rect = node.getBoundingClientRect()
            setSize(previous => (previous.width === rect.width && previous.height === rect.height ? previous : { width: rect.width, height: rect.height }))
        }

        update()

        if (typeof ResizeObserver === 'undefined') return

        const observer = new ResizeObserver(update)
        observer.observe(node)

        return () => observer.disconnect()
    }, [ref])

    return size
}
